import { Button, ButtonProps, Typography } from "@mui/material";
import { sxButton } from "../sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { ReactElement } from "react";

export default function ButtonAccessibility({ children, ...props }: ButtonProps) {

    const { buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();


    return (
        <Button style={buttonStyleAccessibility} type='submit' variant='contained' sx={sxButton} {...props}>
            <Typography style={buttonTextStyleAccessibility}>{children}</Typography>
        </Button>
    )
}
